import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { FaList, FaPen, FaPlusCircle } from "react-icons/fa";
import { MdAddAPhoto } from "react-icons/md";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";

import { useLayout } from "@/../_metronic/layout/core";
import { TrackList } from "@/@types/app/TrackList";
import { getAllTrackLists } from "@/services/app/trackListService";

import { ModalTrackListEdit } from "./ModalTrackListEdit";
import { ModalTrackListImageEdit } from "./ModalTrackListImageEdit";

export function TrackListManagement() {
	const { setTitle } = useLayout();
	const navigate = useNavigate();
	const [selectedTrackList, setSelectedTrackList] = useState<TrackList>({} as TrackList);
	const [trackLists, setTrackLists] = useState<TrackList[]>([]);

	async function fetchTrackLists() {
		setTrackLists(await getAllTrackLists());
	}

	const [showModalTrackListEdit, setShowModalTrackListEdit] = useState(false);
	const [showModalTrackListImageEdit, setShowModalTrackListImageEdit] = useState(false);

	useEffect(() => {
		fetchTrackLists();
		setTitle("GERENCIAMENTO DE PLAYLIST");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<section className="bg-white p-4">
			<ModalTrackListEdit
				selectedTrackList={selectedTrackList}
				fetchTrackLists={fetchTrackLists}
				show={showModalTrackListEdit}
				onHide={() => setShowModalTrackListEdit(false)}
			/>
			<ModalTrackListImageEdit
				show={showModalTrackListImageEdit}
				onHide={() => setShowModalTrackListImageEdit(false)}
				onSuccess={async () => {
					await fetchTrackLists();
					setShowModalTrackListImageEdit(false);
				}}
				trackList={selectedTrackList}
			/>
			<div className="d-flex justify-content-between my-2">
				<h1 className="text-primary fs-4">PlayLists</h1>
				<Button onClick={() => navigate("/configuracoes/track-lists/novo")}>
					<FaPlusCircle className="me-2" />
					Novo
				</Button>
			</div>
			<Table
				striped
				responsive
				className="table align-middle fs-6 dataTable no-footer bg-white rounded"
			>
				<thead>
					<tr className="fw-bold text-center text-black">
						<th>Capa</th>
						<th>Titulo</th>
						<th>Descrição</th>
						<th>Ações</th>
					</tr>
				</thead>
				<tbody>
					{trackLists.map((trackList, index) => (
						<tr className="text-muted text-center p-2" key={`trackList-${index}`}>
							<td style={{ position: "relative" }}>
								<img
									className="d-inline-block"
									height={100}
									loading="lazy"
									src={trackList.urlThumbnail}
									alt={trackList.title}
								/>
								<div style={{ position: "absolute", bottom: 16, right: 16 }}>
									<button
										title="Editar imagem"
										onClick={() => {
											setShowModalTrackListImageEdit(true);
											setSelectedTrackList(trackList);
										}}
										className="rounded-circle"
										style={{ width: "30px", height: "30px" }}
									>
										<MdAddAPhoto />
									</button>
								</div>
							</td>
							<td>{trackList.title}</td>
							<td>{trackList.description}</td>
							<td>
								<div className="d-flex justify-content-center gap-2">
									<Button
										onClick={() => {
											setShowModalTrackListEdit(true);
											setSelectedTrackList(trackList);
										}}
										title="Editar"
										variant="warning"
									>
										<FaPen />
									</Button>
									<Button
										title="Gerenciar Videos"
										variant="secondary"
										onClick={() =>
											navigate(`/configuracoes/track-lists/${trackList.id}`)
										}
									>
										<FaList />
									</Button>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</Table>
		</section>
	);
}
